import { connect } from 'react-redux';
import { toggleFeedbackPage } from '../../redux/actions';
var mapDispatchToProps = {
    toggleFeedbackPage: toggleFeedbackPage,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=NotificationsDropdownWrapperMobile.container.js.map